import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import JournalEntryForm from 'containers/JournalEntryForm';

import JournalEntry from './JournalEntry';
import JournalPageSelector from './JournalPageSelector';

import { JournalEntryShape } from 'entities';
import * as actions from 'actions';
import { getJournalPaging, getJournalEntries, getJournalEmojis } from 'selectors';

import './style.scss';

class Journal extends Component {

  constructor() {
    super();

    this.renderJournalEntries = this.renderJournalEntries.bind(this);
  }

  componentDidMount() {
    this.props.onJournalEntriesFetch();
    this.props.onJournalEmojisFetch();
  }

  renderJournalEntries() {
    return this.props.journalEntries.map(journalEntry => {
      return (
        <JournalEntry
          key={journalEntry.id}
          journalEntry={journalEntry}
        />
      );
    });
  }
  renderJournalEntriesForLoading() {
    return (
      <div>
        <JournalEntry isEmpty />
        <JournalEntry isEmpty />
        <JournalEntry isEmpty />
        <JournalEntry isEmpty />
        <JournalEntry isEmpty />
      </div>
    );
  }

  render() {
    return (
      <section className="Journal content-wrapper has-background">
        <div className="wrapper-small is-collapsed is-padded-vertical">

          <div className="feed-layout">
            <div className="title">
              <h1>{__('members.journal.title')}</h1>
            </div>
            <div className="container">
              <div className="wrapper-small is-collapsed">

                <JournalEntryForm
                  title={__('members.journal.entryForm.title')}
                  text={__('members.journal.entryForm.text')}
                  emojis={this.props.emojis}
                />

                {(() => {
                  if(this.props.journalEntries.length > 0) {
                    return this.renderJournalEntries();
                  }
                  else if(this.props.isFetching) {
                    return this.renderJournalEntriesForLoading();
                  }
                })()}

                {this.props.pagesCount > 1 && <JournalPageSelector />}
              </div>
            </div>
          </div>

        </div>
      </section>
    );
  }
}

Journal.propTypes = {
  onJournalEntriesFetch: PropTypes.func,
  onJournalEmojisFetch: PropTypes.func,
  journalEntries: PropTypes.arrayOf(JournalEntryShape),
  emojis: PropTypes.arrayOf(React.PropTypes.string),
  pagesCount: PropTypes.number,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => {
  const { page, isFetching, pagesCount } = getJournalPaging(state);

  return {
    journalEntries: getJournalEntries(state, { page }),
    emojis: getJournalEmojis(state).emojis,
    isFetching,
    pagesCount
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onJournalEntriesFetch: () => {
      dispatch(actions.journalEntriesFetch());
    },
    onJournalEmojisFetch: () => {
      dispatch(actions.journalEmojisFetch());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Journal);




/** WEBPACK FOOTER **
 ** ./src/members/Main/Journal/index.js
 **/